import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import agencyDetails from './agencyDetails'
import appState from './appState'
import ships from './ships'
import brands from './brands'
import stateOptions from './stateOptions'
import relatedSailings from './relatedSailings'
import destinations from './destinations'
import rfpForm from './rfpForm'
import labelsData from './labelsData'
import activePackage from './activePackage'
import shipStateRooms from './shipStateRooms'
import availableSailingDates from './availableSailingDates'
import initialPackage from './initialPackage'
import availablePackages from './availablePackages'
import activeSearchParameters from './activeSearchParameters'
import itineraryData from './itineraryData'
const rootReducer = combineReducers({
  activePackage,
  initialPackage,
  availablePackages,
  activeSearchParameters,
  itineraryData,
  agencyDetails,
  appState,
  brands,
  destinations,
  form,
  labelsData,
  relatedSailings,
  rfpForm,
  stateOptions,
  ships,
  shipStateRooms,
  availableSailingDates
})

export default rootReducer
